import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { Header } from './header';

export const EmptyQueue = props => (
  <div className="notification-queue-empty">
    <Header {..._.omit(props.header, 'text')} isUINext={props.isUINext} i18n={props.i18n} />
    <div className="empty-content">
      <span className="glasses" />
      <span className="empty-text">
        {props.emptyText}
      </span>
    </div>
  </div>
);

EmptyQueue.propTypes = {
  header: PropTypes.instanceOf(Object).isRequired,
  emptyText: PropTypes.string.isRequired,
  isUINext: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
